import { render } from "./ConfirmOTP.vue?vue&type=template&id=119a5dff&scoped=true"
import script from "./ConfirmOTP.vue?vue&type=script&lang=js"
export * from "./ConfirmOTP.vue?vue&type=script&lang=js"

import "./ConfirmOTP.vue?vue&type=style&index=0&id=119a5dff&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-119a5dff"],['__file',"src/BinaryFlow/components/Account/ConfirmOTP.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "119a5dff"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('119a5dff', __exports__)) {
    api.reload('119a5dff', __exports__)
  }
  
  module.hot.accept("./ConfirmOTP.vue?vue&type=template&id=119a5dff&scoped=true", () => {
    api.rerender('119a5dff', render)
  })

}


export default __exports__